import { CheckNotes, InspectionCase } from '../inspection-cases';

export class BeamsAndPartitionsDto extends InspectionCase {
  item_8_1?: InspectionCase;
  item_8_2_1?: InspectionCase;
  item_8_2_2?: InspectionCase;
}

export class BeamsAndPartitions extends BeamsAndPartitionsDto {
  constructor(data: BeamsAndPartitionsDto = { title: 'קורות ומחיצות' }) {
    super(data);
    this.item_8_1 = new InspectionCase({
      ...data.item_8_1,
      title:
        'אם החדר מופרד בעזרת מחיצה או מדף והמרחק בין החלק העליון  של המחיצה לתקרה קטן מ – - 15% מגובה החלל, יותקנו גלאים משני עברי המחיצה'
    });
    this.item_8_2_1 = new InspectionCase({
      ...data.item_8_2_1,
      title:
        'אם גובה הקורה h שווה ל-10% או גדול מ- 10% מגובה החלל H – והיחס בין גובה הקורה למרחק בין הקורות שווה או גדול מ- 40% - הגלאים יותקנו בכל חלל שבין הקורות'
    });
    this.item_8_2_2 = new InspectionCase({
      ...data.item_8_2_2,
      title: `אם גובה הקורה h שווה ל-10% או גדול מ- 10% מגובה החלל H – והיחס בין גובה הקורה למרחק בין הקורות קטן מ- 40% - הגלאים יותקנו במקביל לקורה כמו בתקרה ישרה (S ) ובניצב לקורות יותקנו מחצית המרחק S/2 ., לפי ציור מס' 6 בתקן`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_8_1.isApplicable || this.item_8_1.isPassed) &&
        (!this.item_8_2_1.isApplicable || this.item_8_2_1.isPassed) &&
        (!this.item_8_2_2.isApplicable || this.item_8_2_2.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_8_1.getNotes(),
      ...this.item_8_2_1.getNotes(),
      ...this.item_8_2_2.getNotes()
    ];
  }
}
